import _ from 'lodash';
import connect from 'components/lib/connect';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { AdminViewIntegrations } from 'components/admin/lib/admin_layout';
import Button, { ButtonTypes } from 'components/common/button';
import DeleteWebhook from 'actions/integrations/webhooks/delete_webhook';
import Err from 'models/err';
import { H2, H3, H4 } from 'components/common/headers';
import LoadingSpinner from 'components/lib/loading_spinner';
import NavigateTo from 'actions/current_location/navigate_to';
import StackContainer from 'components/common/containers/stack_container';
import UpdateWebhook from 'actions/integrations/webhooks/update_webhook';
import Webhook from 'models/webhook';
import WebhookEditor from 'models/location/integrations/webhook_editor';
import WebhookError from './webhook_error';
import WebhooksTable from './webhooks_table';

const WebhooksHeader = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 45px;
  justify-content: space-between;
  margin: 60px 10px 0px;
`;

const StyledImage = styled.div`
  background-image: url(images/webhooks.svg);
  background-repeat: no-repeat;
  background-size: 541px 473px;
  height: 473px;
  width: 541px;
`;

const StyledH3 = styled(H3)`
  flex: 1 1 auto;
`;

const StyledWebhookErrorContainer = styled.div`
  padding-right: 20px;
`;

export function WebhookList({
  isLoading = true,
  webhooks = [],
  errors = {},
  onClickNew,
  onClickWebhook,
  deleteWebhook,
  updateWebhook,
}) {
  if (isLoading) {
    return (
      <AdminViewIntegrations isIntegrationsPageV2Enabled className="webhooks">
        <LoadingSpinner />
      </AdminViewIntegrations>
    );
  }

  if (!webhooks.length) {
    return (
      <AdminViewIntegrations className="webhooks">
        <WebhookTableZeroState onClickNew={onClickNew} />
      </AdminViewIntegrations>
    );
  }

  return (
    <AdminViewIntegrations className="webhooks">
      <WebhooksHeader>
        <StyledH3>Webhooks</StyledH3>
        <StyledWebhookErrorContainer>
          <WebhookError errors={_.map(_.first(_.values(errors)), 'detail')} />
        </StyledWebhookErrorContainer>
        <AddWebhookButton onClickNew={onClickNew} />
      </WebhooksHeader>
      <WebhooksTable
        deleteWebhook={deleteWebhook}
        onClickWebhook={onClickWebhook}
        updateWebhook={updateWebhook}
        webhooks={webhooks}
      />
    </AdminViewIntegrations>
  );
}

WebhookList.propTypes = {
  deleteWebhook: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.instanceOf(Err))),
  isLoading: PropTypes.bool,
  onClickNew: PropTypes.func.isRequired,
  onClickWebhook: PropTypes.func.isRequired,
  updateWebhook: PropTypes.func.isRequired,
  webhooks: PropTypes.arrayOf(PropTypes.instanceOf(Webhook)).isRequired,
};

export const WebhookZeroStateContainer = styled(StackContainer)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

export function WebhookTableZeroState({ onClickNew }) {
  return (
    <WebhookZeroStateContainer>
      <StyledImage />
      <H2>Start building webhooks!</H2>
      <H4>Before we can send you data,</H4>
      <H4>we'll need to figure out where to send it</H4>
      <AddWebhookButton onClickNew={onClickNew} />
    </WebhookZeroStateContainer>
  );
}

WebhookTableZeroState.propTypes = {
  onClickNew: PropTypes.func.isRequired,
};

export const WebhookButton = styled(Button)`
  flex: 0 1 auto;
`;

function AddWebhookButton({ onClickNew }) {
  return (
    <WebhookButton onClick={onClickNew} buttonType={ButtonTypes.PRIMARY} data-aid="webhook-add">
      Create webhook
    </WebhookButton>
  );
}

AddWebhookButton.propTypes = {
  onClickNew: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapExecuteToProps)(WebhookList);

function mapStateToProps({ getProvider }) {
  return {
    errors: getProvider('webhooks').getAllErrors(),
    isLoading: getProvider('webhooks').isLoading(),
    webhooks: getProvider('webhooks').findAll(),
  };
}

function mapExecuteToProps(executeAction) {
  return {
    deleteWebhook: webhookId => executeAction(DeleteWebhook, webhookId),
    onClickNew: () => executeAction(NavigateTo, WebhookEditor.create({})),
    onClickWebhook: webhookId => executeAction(NavigateTo, WebhookEditor.create({ webhookId })),
    updateWebhook: webhook => executeAction(UpdateWebhook, webhook),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/webhooks_list.jsx